export enum CourseLevel {
    Mobile_Leap = 1,
    BootCamp = 2,
    Advanced = 3,
    LG_High_School = 4
}

export const courseLevels = Object.values(CourseLevel).filter((v) => !isNaN(Number(v))) as number[];